import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import React, { useEffect } from 'react';

interface TextEditorProps {
  value: string;
  editable?: boolean;
  placeholder?: string;
  onChange: (value: string) => void;
}

const extensions = [
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
  }),
]

const TextEditor: React.FC<TextEditorProps> = ({ value, onChange, placeholder, editable = true }) => {
  const editor = useEditor({
    extensions,
    editable,
    content: value,
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
    editorProps: {
      attributes: {
        style: 'mix-height: 200px; outline: none;',
        placeholder: placeholder || '',
      },
    },
  });

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value || '', false);
    }
  }, [value, editor]);

  return (
    <div style={{
      border: '1px solid #ccc',
      borderRadius: '10px',
      padding: '16px 25px',
      maxHeight: '448px',
      width: '100%',
      overflow: 'auto',
      overflowY: 'auto',
      boxSizing: 'border-box',
    }}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default TextEditor; 